import { c as _c } from "react/compiler-runtime";
import { Skeleton, type SkeletonProps } from '@mui/material';
export function CommonSkeleton(additionalProps) {
  const $ = _c(8);
  let additionalSxProps;
  let restAdditionalProps;
  if ($[0] !== additionalProps) {
    ({
      sx: additionalSxProps,
      ...restAdditionalProps
    } = additionalProps);
    $[0] = additionalProps;
    $[1] = additionalSxProps;
    $[2] = restAdditionalProps;
  } else {
    additionalSxProps = $[1];
    restAdditionalProps = $[2];
  }
  let t0;
  if ($[3] !== additionalSxProps) {
    t0 = {
      borderRadius: 0,
      ...additionalSxProps
    };
    $[3] = additionalSxProps;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== restAdditionalProps || $[6] !== t0) {
    t1 = <Skeleton animation={false} {...restAdditionalProps} sx={t0} />;
    $[5] = restAdditionalProps;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}